module.exports = __webpack_public_path__ + "media/images/countrysquared/ga-29308c52d05323f63ed797f0a48c7521.svg";